import React, { Component } from 'react';
import Loading from '../../../../components/Loading';
import ReactModal from '../../../../components/Modal';
import AiTrackingAdd from '../../create';
import { withTranslation } from 'react-i18next';

class EditKeywordModal extends Component {
    constructor() {
        super();

        this.submitButtonRef = React.createRef(null);
        this.onEdit = this.onEdit.bind(this);
        this.onChangeLoading = this.onChangeLoading.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            isLoading: false,
        };
    }

    onEdit() {
        if (this.submitButtonRef.current) {
            this.onChangeLoading(true);
            this.submitButtonRef.current?.click();
        }
    }

    onChangeLoading(bool) {
        this.setState({
            isLoading: bool,
        });
    }

    onSubmit() {
        this.onChangeLoading(false);
        this.props.getKeywords();
        this.props.onClose();
    }

    render() {
        const { t } = this.props;

        return (
            <ReactModal
                modalState={this.props.isOpen}
                className="ai-tracking-edit-keyword-container ai-tracking-modal"
                onClose={this.props.onClose}
            >
                <h3>{t('ai_tracking.keyword_manager.edit_keyword.header')}</h3>
                <div className="ai-tracking-edit-keyword-container-body ai-tracking-modal-body px-12">
                    <AiTrackingAdd
                        editMode
                        item={this.props.item}
                        submitButtonRef={this.submitButtonRef}
                        onChangeLoading={this.onChangeLoading}
                        onSubmit={this.onSubmit}
                        isModal
                    />
                </div>
                <div className="btn-wrapper ai-tracking-modal-footer">
                    <button
                        className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center"
                        disabled={this.state.isLoading}
                        onClick={this.onEdit}
                    >
                        <span style={{ marginRight: '5px' }}>
                            {t('ai_tracking.keyword_manager.edit_keyword.save')}
                        </span>
                        {this.state.isLoading && <Loading onlyPreloader />}
                    </button>
                    <button
                        type="button"
                        className="button button-outline button-primary width-sm btn"
                        onClick={this.props.onClose}
                        style={{ lineHeight: 'unset' }}
                    >
                        {t('ai_tracking.keyword_manager.edit_keyword.close')}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(EditKeywordModal);
